import { Brain, Loader2, Sparkles } from "lucide-react";

const MistralGuidanceChip = ({ provider, loading, className = "" }) => {
  if (loading) {
    return (
      <span className={className || "inline-flex items-center gap-1 text-xs font-medium text-blue-700"}>
        <Loader2 size={14} className="animate-spin" />
        AI analysing…
      </span>
    );
  }
  if (provider === "mistral") {
    return (
      <span className={className || "inline-flex items-center gap-1 text-xs font-medium text-blue-700"}>
        <Brain size={14} />
        Mistral-powered
      </span>
    );
  }
  return (
    <span className={className || "inline-flex items-center gap-1 text-xs font-medium text-amber-700"}>
      <Sparkles size={14} />
      Rule-based fallback
    </span>
  );
};

export default MistralGuidanceChip;
